import AButton from "core/presentation/components/Button";
import ATitle from "core/presentation/components/Title";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import Loader from "core/presentation/components/Loader";
import { RootState } from "core/presentation/store";
import { useSelector } from "react-redux";
import { userThunks } from "user/presentation/store/userSlice";
import { getRoleCode } from "core/presentation/utils/Helper";
import PaginationTable from "core/presentation/components/PaginationTable";

const DriverDetailsList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [driverList, setDriverList] = useState<any>();
  const { userProfile } = useAppSelector((state) => state.user);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<any>();
  const roleCode = getRoleCode();
  const isVehicleOwner = roleCode === "VEHICLE_OWNER";
  const haveAction =
    userProfile?.user?.permissions.includes("driver:delete") ||
    userProfile?.user?.permissions.includes("driver:update") ||
    userProfile?.user?.permissions.includes("driver:detail");
  const [currentPage, setCurrentPage] = useState<number>(1);

  const getDrivers = async (
    page?: number,
    input?: string,
    filterValue?: string
  ) => {
    dispatch(
      userThunks.getAllDriverThunk({
        page: page ?? 0,
        input: input ?? "",
        filter: filterValue ?? "",
        limit:10,
      })
    );
  };

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Contact No.", dataIndex: "contact", key: "contact" },
    { title: "Assigned Vehicle", dataIndex: "assign", key: "assign" },
    ...(!isVehicleOwner
      ? [{ title: "Vehicle Owner", dataIndex: "owner", key: "owner" }]
      : []),
    { title: "Status", dataIndex: "accountStatus", key: "accountStatus" },
    ...(haveAction
      ? [
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
          },
        ]
      : []),
  ];
  const { drivers, isLoading, driverCount, error } = useSelector(
    (state: RootState) => state.user
  );

  useEffect(() => {
    if (drivers) {
      setDriverList(drivers);
    }
  }, [drivers]);

  useEffect(() => {
    getDrivers(currentPage);
  }, [dispatch]);

  // const handleDelete = async (id: any) => {
  //   try {
  //     await dispatch(userThunks.deleteDriverThunk(id));
  //     message.success("Driver deleted successfully");
  //     setDeleteModalVisible(false);
  //   } catch (error) {
  //     message.error("Driver delete failed");
  //   }
  // };

  // const showDeleteConfirm = (id: any) => {
  //   setSelectedUserId(id);
  //   setDeleteModalVisible(true);
  // };

  // const handleCreateDriver = () => {
  //   navigate("/driver/create");
  // };

  if (!driverList) {
    <Loader />;
  }
  const driveListDataSource = [
    driverList?.map((data: any) => ({
      key: data.driverId,
      name: `${data?.user?.firstName} ${data?.user?.lastName}`,
      accountStatus: data?.user?.accountStatus,
      contact: data?.user?.contactNumber,
      assign: data?.user?.assign || "N/A",
      owner:
        `${data.vehicleOwner?.userId?.firstName} ${data.vehicleOwner?.userId?.lastName}` ||
        "N/A",
      action: (
        <>
          {userProfile?.user?.permissions.includes("driver:detail") && (
            <AButton
              style={{
                marginTop: "0",
                padding: "5px",
                color: "#F26533",
                fontSize: "14px",
                fontWeight: "600",
              }}
              type="text"
              onClick={() => navigate(`/driver/details/${data?.driverId}`)}
            >
              View
            </AButton>
          )}
        </>
      ),
      date: data.updated_at,
    })),
  ];

  return (
    <div>
      {loading && <Loader />}
      {!loading && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <ATitle
                content={"Driver Details"}
                fontSize={14}
                fontWeight={600}
              />
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <PaginationTable
              dataSource={driveListDataSource[0]}
              columns={columns}
              tableTitle="Driver List"
              totalData={driverCount}
              handleChange={getDrivers}
              loading={loading || isLoading}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default DriverDetailsList;
